export default __webpack_public_path__ + "static/media/accessed_on_PC.623e86d4.svg";